module.exports = __webpack_public_path__ + "img/agency-slide-03.95f5cb3a.jpg";